/**
 *  @class
 *  @function BackToTop
 */

// window.addEventListener("scroll", function () {
//     const totop = document.querySelector(".totop");
//     const bodyHeight = document.body.clientHeight;
//     const windowScrollHeight =
//         document.documentElement.clientHeight +
//             document.documentElement.scrollTop ||
//         document.body.scrollTop ||
//         document.scrollingElement.scrollTop ||
//         window.pageYOffset ||
//         window.scrollY;
//     const footerHeight = document.querySelector(".footer").clientHeight;
//     if (bodyHeight - windowScrollHeight <= footerHeight) {
//         totop.style.position = "absolute";
//         totop.style.bottom = footerHeight + -20 + "px";
//     } else {
//         totop.style.position = "fixed";
//         totop.style.bottom = "15px";
//     }
// });

// const pagetopBtn = document.querySelector(".totop");
// pagetopBtn.addEventListener("click", () => {
//     window.scrollTo({
//         top: 0,
//         behavior: "smooth",
//     });
// });

// if (!customElements.get("back-to-top")) {
//     class BackToTop extends HTMLElement {
//         constructor() {
//             super();
//             this.pageHeight = window.innerHeight;
//             this.footerSelector = ".footer";
//         }

//         connectedCallback() {
//             this.footer = document.querySelector(this.footerSelector);
//             this.addEventListener("click", this.onClick);
//             this.addEventListener("touchstart", this.onClick);
//             window.addEventListener("scroll", this.checkVisible.bind(this));
//         }

//         checkVisible(event) {
//             window.requestAnimationFrame(() => {
//                 let y = window.scrollY;
//                 let windowHeight = window.innerHeight;
//                 let bodyHeight =
//                     windowHeight - (this.footer ? this.footer.clientHeight : 0);

//                 if (y > this.pageHeight) {
//                     this.classList.add("back-to-top--active");
//                 } else {
//                     this.classList.remove("back-to-top--active");
//                 }

//                 if (
//                     y >= bodyHeight &&
//                     y + windowHeight <=
//                         this.pageHeight + this.footer.clientHeight
//                 ) {
//                     // スクロールがフッターに到達した場合の処理
//                     this.style.position = "absolute";
//                     this.style.bottom = "100px";
//                 } else {
//                     this.style.position = "fixed";
//                     this.style.bottom = "20px";
//                 }
//             });
//         }

//         onClick() {
//             window.scrollTo({
//                 top: 0,
//                 left: 0,
//                 behavior: "smooth",
//             });
//         }
//     }
//     customElements.define("back-to-top", BackToTop);
// }

// if (!customElements.get("back-to-top")) {
//     class BackToTop extends HTMLElement {
//         constructor() {
//             super();
//             this.pageHeight = 100;
//             this.footerSelector = ".footer";
//         }

//         connectedCallback() {
//             this.footer = document.querySelector(this.footerSelector);
//             this.addEventListener("click", this.onClick);
//             this.addEventListener("touchstart", this.onClick);
//             window.addEventListener("scroll", this.checkVisible.bind(this));
//         }

//         checkVisible(event) {
//             window.requestAnimationFrame(() => {
//                 let y = window.scrollY;
//                 let windowHeight = window.innerHeight;
//                 let bodyHeight = this.windowHeight - (this.footerSelector: 0);

//                 if (y > this.pageHeight) {
//                     this.classList.add("back-to-top--active");
//                 } else {
//                     this.classList.remove("back-to-top--active");
//                 }
//                 if (y >= bodyHeight) {
//                     this.style.position = "absolute";
//                     this.style.bottom = "100px";
//                 } else {
//                     this.style.position = "fixed";
//                     this.style.bottom = "20px";
//                 }
//             });
//         }

//         onClick() {
//             window.scrollTo({
//                 top: 0,
//                 left: 0,
//                 behavior: "smooth",
//             });
//         }
//     }
//     customElements.define("back-to-top", BackToTop);
// }

//トップへ戻るボタン
$(function () {
    const pagetop = $("#js-pagetop");
    pagetop.hide(); //最初はボタンを非表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            //100px以上スクロールしたら
            pagetop.fadeIn(); //ボタンをフェードイン
        } else {
            pagetop.fadeOut(); //ボタンをフェードアウト
        }
    });
    pagetop.click(function () {
        $("body,html").animate(
            {
                scrollTop: 0, //上から0pxの位置に戻る
            },
            400
        ); //400ミリ秒かけて上に戻る
        return false;
    });
});

//フッター手前で止まるボタン
$(document).ready(function () {
    $("#js-pagetop").hide();
    $(window).on("scroll", function () {
        var scrollHeight = $(document).height(); //ドキュメントの高さ
        var scrollPosition = $(window).height() + $(window).scrollTop(); //現在の位置
        var footHeight = $("#footer").innerHeight(); //フッターの高さ
        var bottomPosition = $(window).width() < 768 ? "95px" : "10px"; // ウィンドウ幅による bottom の値の分岐
        if (scrollHeight - scrollPosition <= footHeight) {
            //ドキュメントの高さと現在の位置の差がフッターの高さ以下のとき
            $("#js-pagetop").css({
                position: "absolute",
                bottom: bottomPosition,
                right: "10px",
            }); //pisitionをabsoluteに変更
        } else {
            //それ以外の場合は
            $("#js-pagetop").css({
                position: "fixed",
                bottom: bottomPosition,
                right: "10px",
            }); //固定で表示
        }
    });
});
